"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
DatetimePickerDirective.$inject = [];
function DatetimePickerDirective() {
    return {
        scope: {
            date: '=ngModel',
            disabled: '='
        },
        template: require('./views/datetime-picker.html'),
        link: function (scope, attrs, elem) {
            scope.hours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
            scope.minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
            var initWatch = true;
            var _format_date = 'YYYY-MM-DD';
            var _format = 'YYYY-MM-DD HH:mm:ss';
            scope.$watch('date', function (val) {
                scope.hourSet = addZero(moment_1.default(new Date(scope.date)).hours());
                scope.minuteSet = addZero(moment_1.default(new Date(scope.date)).minutes());
                scope.dateSet = moment_1.default(new Date(scope.date)).format(_format_date);
                initWatch = false;
            });
            function addZero(i) {
                if (i < 10) {
                    i = "0" + i;
                }
                return i;
            }
            scope.setHours = function (h) {
                var date = moment_1.default(scope.dateSet, _format_date);
                date.hours(h);
                date.minutes(scope.minuteSet);
                date.seconds(0);
                scope.date = date.format(_format);
            };
            scope.setDate = function (d) {
                var date = moment_1.default(d, _format_date);
                date.hours(scope.hourSet);
                date.minutes(scope.minuteSet);
                date.seconds(0);
                scope.date = date.format(_format);
            };
            scope.setMinutes = function (m) {
                var date = moment_1.default(scope.dateSet, _format_date);
                date.hours(scope.hourSet);
                date.minutes(m);
                date.seconds(0);
                scope.date = date.format(_format);
            };
        }
    };
}
angular.module('profumo.core.directives.datetime-picker', [])
    .directive('datetimepicker', DatetimePickerDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/DatetimePickerDirective.ts
// module id = 457
// module chunks = 0